import type { ConsequenceByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetConsequencesByParentIssueIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetConsequencesByParentIssueIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetConsequencesByParentIssueIdArgs = {
  parentIssueId: string;
};

export const useLazyGetConsequencesByParentIssueId = createLazyQueryHook<
  UseLazyGetConsequencesByParentIssueIdArgs,
  ConsequenceByIdResponseRow[],
  GetConsequencesByParentIssueIdQuery
>({
  trpcQuery: (client, { parentIssueId }) =>
    client.frontend.consequence.getByParentIssueId.query({
      issueId: parentIssueId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ consequence: data }),
  graphqlDocument: GetConsequencesByParentIssueIdDocument,
  graphqlVariables: ({ parentIssueId }) => ({ _eq: parentIssueId }),
});
